/*
 * @Description: 跟进管理模块数据字典
 * @Author: mdb
 * @Date: 2022-07-19 10:48:56
 * @LastEditTime: 2023-03-10 11:07:15
 * @LastEditors: cxh
 */

// 计划状态枚举
export const planStatusEnum = [
  { label: '未开始', value: 1, color: '#1D4CD2', lang: 'enum.planStatus1' },
  { label: '已结束', value: 2, color: '#EF8D3C', lang: 'enum.planStatus2' },
  { label: '已完成', value: 3, color: '#3FAC46', lang: 'enum.planStatus3' }
]
// 访客提醒枚举
export const remindTypeEnum = [
  { label: '不提醒', value: 1, lang: 'enum.remindType1' },
  { label: '提前1小时提醒', value: 2, lang: 'enum.remindType2' },
  { label: '提前1天提醒', value: 3, lang: 'enum.remindType3' },
  { label: '其它时间', value: 4, lang: 'enum.remindType4' }
]

export default { planStatusEnum, remindTypeEnum }
